<template>
    <div class="position-fixed fixed-top alert fade bg-white mx-auto container mt-5"
         :class="[type, show ? 'show' : 'd-none']" role="alert" id="vue-alert">
        <div class="d-flex justify-content-between align-items-center">
            <p v-html="message" class="m-0"></p>
            <span v-on:click="dismiss()" class="d-block"><i class="fas fa-times-circle d-block"></i></span>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'type',
        'message',
        'show',
    ],

    mounted() {
        document.getElementById("vue-alert").addEventListener("mouseenter", () => {
            document.getElementById("vue-alert").classList.remove("fading-away");
        });

        document.getElementById("vue-alert").addEventListener("click", () => {
            document.getElementById("vue-alert").classList.remove("fading-away");
        });

        const transitionEnd = () => {
            if(document.getElementById("vue-alert").classList.contains("fading-away")) {
                this.dismiss();
            }
        }

        document.getElementById("vue-alert").addEventListener("transitionend", transitionEnd);
        document.getElementById("vue-alert").addEventListener("webkitTransitionEnd", transitionEnd);
        document.getElementById("vue-alert").addEventListener("oTransitionEnd", transitionEnd);


        setTimeout(() => {
            document.getElementById("vue-alert").classList.add("d-none");
        }, 10000);
    },

    watch: {
        show: function (newVal, oldVal) {
            document.getElementById("vue-alert").classList.remove("fading-away");

            if (newVal) {
                setTimeout(() => {
                    document.getElementById("vue-alert").classList.add("fading-away");
                }, 2000);
            }
        }
    },

    methods: {
        dismiss() {
            this.$root.alertShow = false;
            this.$root.alertMessage = null;
            this.$root.alertType = null;
            document.getElementById("vue-alert").classList.remove("fading-away");
        }
    }
};
</script>
